export default {
  message: {
    "strid1": "Início",
    "strid2": "Tutorial",
    "strid3": "Evento",
    "strid4": "Junte-se a Nós",
    "strid5": "Discord",
    "strid6": "Concurso de Criadores",
    "strid7": "Trabalhos Selecionados",
    "strid8": "Voltar",
    "strid9": "Participar Agora",
    "strid10": "Mais Eventos",
    "strid11": "Informações Pessoais",
    "strid12": "ID do Servidor",
    "strid13": "Por favor insira sua ID do Servidor",
    "strid14": "ID da Conta",
    "strid15": "Por favor, insira sua ID de Jogo",
    "strid16": "Informações de Contato",
    "strid17": "Selecione a Plataforma",
    "strid18": "Por favor, insira suas informações para contato",
    "strid19": "Detalhes de Trabalho",
    "strid20": "Plataforma de Publicação",
    "strid21": "Por favor, insira um link correto",
    "strid22": "Toque para adicionar um novo link",
    "strid23": "Idioma usado",
    "strid24": "Selecione o idioma usado",
    "strid25": "Inglês",
    "strid26": "Árabe",
    "strid27": "Espanhol",
    "strid28": "Português",
    "strid29": "Khmer",
    "strid30": "Birmanês",
    "strid31": "Malaio",
    "strid32": "Outro",
    "strid33": "Eu confirmo a propriedade da obra e reconheço este acordo",
    "strid34": "Enviar",
    "strid35": "Enviado!",
    "strid36": "Regalias",
    "strid37": "Junte-se a nós agora para obter",
    "strid38": "Suporte da mídia social oficial do MLBB",
    "strid39": "Comunidade interativa de criadores",
    "strid40": "Recompensa semanal em Diamante",
    "strid41": "Mais regalias",
    "strid42": "Merchandise do jogo",
    "strid43": "Eventos offline",
    "strid44": "Muitas skins",
    "strid45": "Colaboração com a marca",
    "strid46": "Promoção de anúncios",
    "strid47": "JUNTE-SE A NÓS",
    "strid48": "Requisitos",
    "strid49": "NOS SIGA",
    "strid50": "Toque para verificar a conta oficial do MLBB",
    "strid51": "Conteúdo do Acordo",
    "strid52": "Por favor complete as informações",
    "strid53": "O envio falhou",
    "strid54": "Por favor, preencha com o link do seu canal",  // 请输入正确的频道链接
    "strid55": "Selecione sua Região",
    "strid56": "Sua Região",



  }
}
